"use client";

import { useTranslations } from "next-intl";
import type * as React from "react";
import { MyInvest } from "@/components/features/staking/MyInvest";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { GlobalStatsTab } from "./GlobalStats/GlobalStatsTab";

export const StakeTabs: React.FC = () => {
  const t = useTranslations("stake");
  return (
    <Tabs
      className="w-full flex flex-col items-start"
      defaultValue="tab-1"
      syncWithHash={false}
    >
      <TabsList variant="bordered" className="w-fit">
        {/* BUG-20: Tab 1 MUST be first in source (renders rightmost in RTL) */}
        <TabsTrigger
          value="tab-1"
          variant="bordered"
          className="w-fit text-sm font-medium"
        >
          {t("tabs.myStake")}
        </TabsTrigger>
        <TabsTrigger
          value="tab-2"
          variant="bordered"
          className="w-fit text-sm font-medium"
        >
          {t("tabs.daoStake")}
        </TabsTrigger>
      </TabsList>
      <TabsContent value="tab-1" className="w-full">
        <MyInvest />
      </TabsContent>
      <TabsContent value="tab-2" className="w-full">
        <GlobalStatsTab />
      </TabsContent>
    </Tabs>
  );
};
